import React, { Component } from 'react'
import { Helmet } from 'react-helmet'

export default class Service extends Component {
  render() {
    return (
      <div className="container my-8">
        <Helmet>
            <title>Service - Service TM</title>
        </Helmet>
      <h2 className="text-xl text-left font-bold my-4">What is Service TW</h2><br />
      <p className='dark:bg-gray-900'>
        Service TW is one of startup to provide excellent service. Service sector
        companies have played a significant role in the tech industry and it's
        motive is to help other tech companies or even governments to provide.
        These we have a lot of service companies lying around and you need the
        right one to fullfill your needs. So Contact Service TW today and quote a
        deal with us.
      </p>
      <p>
        {/* Write a essay on service sector companies and how they are working in
        the industry. */}
        Nowdays There are very less service sector companies in the industry, which provide good service to the customers.
        But there are many service sector companies which are working in the industry and they are providing good service to the customers.
        So Service TW is one of startup to provide excellent service. Service sector companies have played a significant role in the tech industry and it's motive is to help other tech companies or even governments to provide.
        These we have a lot of service companies lying around and you need the right one to fullfill your needs. So Contact Service TW today and quote a deal with us.
        Difference between the service sector companies and the other companies is that they are working in the industry and they are providing good service to the customers.
        Service TW has just started and it's working in the industry and it's providing good service to the customers.
        Its' provide good service to the customers.
      </p>
      <h1 className="text-xl text-left font-bold my-4">
        Why Service TW is one of startup to provide excellent service.
      </h1>
      <p> 
        Because we believe in quality service to the customers and we are working in the industry and we are providing good service to the customers.
        Service TW has just started and it's working in the industry and it's providing good service to the customers.
        Its' provide good service to the customers.
      </p>
      <h1 className="text-xl text-left font-bold my-4">
        Why Service TW is one of startup to provide excellent service.
      </h1>
      <p>
        Because we believe in quality service to the customers and we are working in the industry and we are providing good service to the customers.
        Service TW has just started and it's working in the industry and it's providing good service to the customers.
        Its' provide good service to the customers.
      </p>
      </div>
    )

  
  }
}
